import { ApiPaths } from './ApiPaths';
import axios from 'axios';

class AccountUpdateApi {
    constructor(errorHandler = null) {
        this.client = axios.create({
            headers: {
                'Content-Type': 'application/json'
            },
        });

        // Set up response interceptor for error handling
        // this.client.interceptors.response.use(
        //     (response) => response,
        //     (error) => {
        //         return Promise.reject(error);
        //     }
        // );
    }

    // Helper method to get auth headers
    getAuthHeader(token) {

        if (token) {
            return { Authorization: `Bearer ${token}` };
        }

        return {};
    }

    async get(url, config = {}, token = null) {
        const headers = { ...config.headers, ...this.getAuthHeader(token) };
        return this.client.get(url, { ...config, headers });
    }

    async getAnonymous(url) {
        return this.client.get(url);
    }

    async patch(url, data = {}, config = {}, token = null) {
        const headers = { ...config.headers, ...this.getAuthHeader(token) };
        return this.client.patch(url, data, { ...config, headers });
    }

    async post(url, data = {}, config = {}, token = null) {
        const headers = {
            ...config.headers,
            ...this.getAuthHeader(token)
        };
        return this.client.post(url, data, { ...config, headers });
    }

    getTokenAsync = async (username) => {
        var response = await this.getAnonymous(ApiPaths.GET_RECOVERY_TOKEN(username));
        if(response.status !== 200) {
            return null;
        }
        return response.data.token;
    }

    verifyUserAsync = async (request) => {
        try {
            var response = await this.post(ApiPaths.VERIFY_USER, {
                username: request.username,
                password: request.password,
                securityQuestionId: request.securityQuestionId,
                securityQuestionAnswer: request.securityAnswer
            }, {}, request.token);
            return {
                token: response.data.token,
                securityQuestionId: response.data.securityQuestionId,
                isAccountLocked: response.data.isAccountLocked,
                errror: null
            };
        } catch (error) {
            // Return empty response for 400 Bad Request
            if (error.response?.data) {
                return error.response.data;
            }
            // Re-throw other errors
            throw error;
        }
    }

    updateEmailAsync = async (newEmail, token) => {
        try {
            var response = await this.patch(ApiPaths.UPDATE_EMAIL, {
                email: newEmail
            }, {}, token);
            return {
                success: response.status === 200,
                errorCode: null
            };
        } catch (error) {
            if (error.response?.data) {
                return {
                    success: false,
                    errorCode: error.response.data.errorCode
                };
            }
            throw error;
        }
    }
}

const api = new AccountUpdateApi();
export default api;